import React, { useEffect, useRef } from "react";
import Chart from "chart.js/auto";
import PropTypes from "prop-types";

const BarChartCard = ({ title, dataPoints, height = "300px" }) => {
  const chartRef = useRef(null);

  useEffect(() => {
    if (!dataPoints || dataPoints.length === 0) return;

    const ctx = chartRef.current.getContext("2d");

    // Destroy previous instance
    if (window.barChart) window.barChart.destroy();

    const labels = dataPoints.map((item) => item.district);
    const institutional = dataPoints.map((item) => item.institutional);
    const csection = dataPoints.map((item) => item.csection);

    window.barChart = new Chart(ctx, {
      type: "bar",
      data: {
        labels,
        datasets: [
          {
            label: "Institutional Deliveries",
            data: institutional,
            backgroundColor: "rgba(59,130,246,0.7)", // Blue
            borderColor: "#3B82F6",
            borderWidth: 1,
            borderRadius: 6,
            barPercentage: 0.5,
          },
          {
            label: "C-Section Deliveries",
            data: csection,
            backgroundColor: "rgba(236,72,153,0.7)", // Pink
            borderColor: "#EC4899",
            borderWidth: 1,
            borderRadius: 6,
            barPercentage: 0.5,
          },
        ],
      },

      options: {
        responsive: true,
        maintainAspectRatio: false,

        plugins: {
          legend: {
            position: "bottom",
            labels: {
              color: "#334155",
              boxWidth: 12,
              font: { size: 12, family: "Inter" },
            },
          },
          tooltip: {
            backgroundColor: "#fff",
            titleColor: "#000",
            bodyColor: "#000",
            borderColor: "#e2e8f0",
            borderWidth: 1,
            displayColors: false,
            padding: 10,
          },
          datalabels: {
            display: false,
          },
        },

        scales: {
          x: {
            stacked: false,
            ticks: {
              color: "#64748b",
              font: { size: 11 },
              maxRotation: 0,
              minRotation: 0,
            },
            grid: { display: false },
          },
          y: {
            ticks: { color: "#64748b", font: { size: 11 } },
            grid: { color: "#f1f5f9" },
          },
        },
      },
    });
  }, [dataPoints, height]);

  return (
    <div className="bg-white rounded-2xl shadow-md p-6 w-full">
      <h6 className="text-base font-semibold text-slate-800 mb-3">{title}</h6>

      <div style={{ height }}>
        <canvas ref={chartRef}></canvas>
      </div>
    </div>
  );
};

/* -------------------- PropTypes -------------------- */
BarChartCard.propTypes = {
  title: PropTypes.string.isRequired,
  dataPoints: PropTypes.arrayOf(
    PropTypes.shape({
      district: PropTypes.string.isRequired,
      institutional: PropTypes.number.isRequired,
      csection: PropTypes.number.isRequired,
    })
  ).isRequired,
  height: PropTypes.string,
};

/* -------------------- Default Props -------------------- */
BarChartCard.defaultProps = {
  height: "300px",
};

export default BarChartCard;
